import { CART_CHECKOUT_ROUTE_PATH } from "@const/route-paths.const";
import Link from "next/link";
import { useState, useEffect } from "react";
import BottomMenus from "./BottomMenus";
import { isWebview } from "@utils/webview.util";
import { getCartId, useCartProducts } from "@api/customer/cart";
import { useRouter } from "next/router";

type Props = {};

const CartViewNavigate = (props: Props) => {
  const router = useRouter();
  const [show, setShow] = useState(false);
  const [cartId, setCartId] = useState<number>();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { data, isLoading, error, mutate } = useCartProducts();

  useEffect(() => {
    if (isWebview()) {
      handleClose();
    } else {
      handleShow();
    }
  }, []);

  useEffect(() => {
    const fetchCartId = async () => await getCartId();

    fetchCartId().then((response) => setCartId(Number(response.data)));
    // .catch(() => router.push("/404"));
  }, [router]);

  return (
    <div className="bottom-navigate fixed-bottom bg-white d-block d-lg-none">
      {cartId && (
        <>
          {data && data?.items !== null && (
            <div className="d-grid d-lg-flex align-items-lg-center p-3">
              <Link href={CART_CHECKOUT_ROUTE_PATH}>
                <a className="btn btn-red me-lg-1" title="ดำเนินการสั่งซื้อ">
                  ดำเนินการสั่งซื้อ
                </a>
              </Link>
            </div>
          )}
        </>
      )}
      <div className={`${show ? "d-block" : "d-none"}`}>
        <BottomMenus handleShow={handleShow} />
      </div>
    </div>
  );
};

export default CartViewNavigate;
